<template>
    <div class="row justify-content-center match-height">

        <div class="col-md-12 d-block mb-4" v-if="!loading">
            <a href="javascript:void(0)" @click="goToEvents()" class="text-danger float-start">
                <b>{{$t('show_all')}}</b>
            </a>
            <h2 class="text-capitalize">{{$t('events')}}</h2>
        </div>
        <div class="col-12 pt-10" v-if="!loading && events.length">

            <carousel :itemsToShow="3.95" :wrapAround="true" :transition="500" :autoplay="2700"
                      :breakpoints="breakpoints" dir="rtl">

                <slide v-for="(_events,key) in events" :key="key">
                    <div class="carousel__item">
                        <div class="card newsCard cursor-pointer" @click="goToShowEvents(_events._id)">
                            <div class="card-body newsRed pb-0">
                                <img :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+_events.image)"
                                     class="img-thumbnail h-150px w-150px" style="border-radius: 10px" alt="">
                            </div>
                            <div class="card-body newsGray pb-1" style="overflow:hidden;">
                                <div>
                                    <h6 class="mt-2" v-if="i18n.locale.value == 'ar'">{{_events.title.ar}}</h6>
                                    <h6 class="mt-2" v-if="i18n.locale.value == 'en'">{{_events.title.en}}</h6>
                                </div>
                                <div class="mt-2">
                                    <button class="btn btn-danger btn-sm btn-" @click="goToShowEvents(_events._id)"
                                            style="border-radius: 50px">
                                        {{$t('show_details')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide>

                <template #addons>
                    <navigation/>
                    <pagination/>
                </template>
            </carousel>

        </div>
        <div class="col-md-12 mb-4" v-if="loading">
            <paragraph-shimmer :lines="3" :random-size="true"/>
        </div>
        <div class="col-md-12 mb-4" v-if="!loading && !events.length">
            <div style="width: 320px;margin: auto">
                <client-only>
                    <Vue3Lottie
                            animationLink="https://assets5.lottiefiles.com/packages/lf20_rc6CDU.json"
                    />
                </client-only>
            </div>
            <h4 class="mt-10 text-center">{{$t('no_data')}}</h4>
        </div>
    </div>
</template>

<script lang="ts">
  import { defineComponent, reactive, toRefs, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';


  export default defineComponent({
    name: 'Events',
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
    setup() {
      const store = useStore();
      const i18n = useI18n();
      const router = useRouter();

      const state = reactive({
        loading: false,
        events: [],
        breakpoints: {
          // 0 and up
          0: {
            itemsToShow: 1,
          },
          // 300px and up
          300: {
            itemsToShow: 1,
          },
          // 600px and up
          600: {
            itemsToShow: 3,
          },
          // 1024 and up
          1024: {
            itemsToShow: 5,
          },
        },
      });

      onMounted(() => {
        getAllEvents();
      });

      const getAllEvents = () => {
        state.loading = true;
        store.dispatch('moduleCommon/getEvents', {
          limit: 6,
          paginated: true,
          page: 1,
        }).then((response) => {
          state.loading = false;
          state.events = response.data.docs;
        }).catch(() => {
          state.loading = false;
        });
      };

      const goToEvents = () => {
        router.push({ name: 'events' });
      };
      const goToShowEvents = (id) => {
        router.push({ name: 'show_events', params: { id: id } });
      };

      return {
        ...toRefs(state),
        store,
        i18n,
        goToEvents,
        goToShowEvents,
      };
    },
  });
</script>
<style>
    @import '~vue3-carousel/dist/carousel.css';

    .carousel__slide {
        padding: 2px;
    }

    .carousel__viewport {
        perspective: 2000px;
    }

    .carousel__track {
        transform-style: preserve-3d;
        padding: 30px 0 !important;
    }

    .carousel__slide--sliding {
        transition: 0.5s;
    }

    .carousel__slide {
        opacity: 0.6;
        transform: rotateY(-20deg) scale(0.9);
    }

    .carousel__slide--active ~ .carousel__slide {
        transform: rotateY(20deg) scale(0.9);
    }

    .carousel__slide--prev {
        opacity: 1;
        transform: rotateY(-10deg) scale(0.95);
    }

    .carousel__slide--next {
        opacity: 0.8;
        transform: rotateY(10deg) scale(0.95);
    }

    .carousel__slide--active {
        opacity: 1;
        transform: rotateY(0) scale(1.1);
    }

    .carousel__track {
        padding: 30px 5px !important;
    }

    .carousel__item {
        min-height: 150px;
        width: 100%;
        margin: 10px;
    }

    .carousel__slide {
        padding: 0;
    }


</style>
